import Button from "@material-ui/core/Button";
import green from "@material-ui/core/colors/green";
import Dialog from "@material-ui/core/Dialog";
import { withStyles, useTheme } from "@material-ui/core/styles";
import React, { useState, useEffect, createRef } from "react";
import { postAxios } from "../../api/Axios";
import { notificationApi } from "../../api/Urls";
import classes from "./AddNotification.module.scss";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../tabPanel/TabPanel";
import Checkbox from "@material-ui/core/Checkbox";
import toFarsiNumber from "util/toFarsiNumber";

const styles = (theme) => ({
  buttonProgress: {
    color: green[500],
  },
});

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const AddNotification = ({
  groupData,
  setGroupData,
  userData,
  setUserData,
  userReceivers,
  groupReceivers,
  setUserReceivers,
  setGroupReceivers,
  setRefreshNotificationList,
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [messageValues, setMessageValues] = useState({
    title: "",
    messageText: "",
  });
  const [elGroupRefs, setElGroupRefs] = useState([]);
  const [elUserRefs, setElUserRefs] = useState([]);

  useEffect(() => {
    // add or remove refs
    setElGroupRefs((elRefs) =>
      Array(groupData?.length)
        .fill()
        .map((_, i) => elRefs[i] || createRef())
    );
  }, [groupData?.length]);

  useEffect(() => {
    // add or remove refs
    setElUserRefs((elRefs) =>
      Array(userData?.length)
        .fill()
        .map((_, i) => elRefs[i] || createRef())
    );
  }, [userData?.length]);

  const handleRequestClose = () => {
    setOpen(false);
    setMessageValues({
      title: "",
      messageText: "",
    });
    setGroupReceivers(groupData.slice().fill(false));
    setUserReceivers(userData.slice().fill(false));
    setGroupData(
      groupData.map((group) => {
        return {
          ...group,
          checked: false,
        };
      })
    );
    setUserData(
      userData.map((user) => {
        return {
          ...user,
          checked: false,
        };
      })
    );
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const userCheckboxHandleChange = (index) => (event) => {
    const newAllSubs = [...userData];
    newAllSubs[index].checked =
      event.target.checked === undefined
        ? !elUserRefs[index]?.current?.children[0]?.children[0]?.checked
        : event.target.checked;
    setUserData(newAllSubs);
    setUserReceivers(userReceivers.map((v, i) => (i === index ? !v : v)));
  };

  const groupCheckboxHandleChange = (index) => (event) => {
    const newAllSubs = [...groupData];
    newAllSubs[index].checked =
      event.target.checked === undefined
        ? !elGroupRefs[index]?.current?.children[0]?.children[0]?.checked
        : event.target.checked;
    setGroupData(newAllSubs);
    setGroupReceivers(groupReceivers.map((v, i) => (i === index ? !v : v)));
  };

  const handleChangeInputs = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox" ? target.checked : toFarsiNumber(target.value);
    const name = target.name;
    if (name === "title" && value.length <= 128) {
      setMessageValues({ ...messageValues, [name]: value });
    }
    if (name === "messageText" && value.length <= 1024) {
      setMessageValues({ ...messageValues, [name]: value });
    }
  };

  const handleSubmitMessage = () => {
    let finalData = new FormData();
    finalData.append("type", 4);
    finalData.append("subject", messageValues.title);
    finalData.append("message", messageValues.messageText);
    const userUuid = userData.filter(
      (user, i) => userReceivers[i] && user.uuid
    );
    for (const i of userUuid) {
      finalData.append("receivers", i.uuid);
    }
    const groupUuid = groupData.filter(
      (group, i) => groupReceivers[i] && group.uuid
    );
    for (const i of groupUuid) {
      finalData.append("groups", i.uuid);
    }
    postAxios(`${notificationApi}`, finalData)
      .then((data) => {
        if (data.status === 200) {
          setRefreshNotificationList((value) => !value);
          handleRequestClose();
          enqueueSnackbar(data.data.message, {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        }
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  useEffect(() => {
    checkMessageValidation();
  }, [messageValues, userReceivers, groupReceivers]);

  const checkMessageValidation = () => {
    const isTrueUser = userReceivers.every((item) => item === false);
    const isTrueGroup = groupReceivers.every((item) => item === false);
    if (!messageValues.title || !messageValues.messageText) {
      setDisableSubmit(true);
    } else {
      if (isTrueUser && isTrueGroup) {
        setDisableSubmit(true);
      } else {
        setDisableSubmit(false);
      }
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Button
          variant="contained"
          className="btn btn-primary jr-btn-uptin"
          onClick={() => setOpen(true)}
        >
          <span>{t("notifications.new_notification")}</span>
        </Button>
        <Dialog
          open={open}
          onClose={handleRequestClose}
          className={classes.dialogRoot}
          maxWidth="md"
          fullWidth
        >
          <div className={`${classes.modalContainer} text-center`}>
            <div>
              <h2 className="m-1">{t("notifications.new_notification")}</h2>
              <div
                className={classes.DescAndInputs}
                style={{
                  alignItems:
                    i18n.language === "en" ? "flex-end" : "flex-start",
                }}
              >
                <p className={classes.description}>
                  {t("notifications.description_of_new_notification")}
                </p>
                <div className={classes.formContainer}>
                  <div className={classes.messageContainer}>
                    <div
                      className={
                        i18n.language === "fa"
                          ? classes.outlinedInputRtl
                          : classes.outlinedInputLtr
                      }
                    >
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="title"
                          onChange={(event) => handleChangeInputs(event)}
                          value={messageValues.title}
                          startAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("notifications.message_title")}
                              </InputAdornment>
                            )
                          }
                          endAdornment={
                            i18n.language === "en" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("notifications.message_title")}
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>

                    <div
                      className={
                        i18n.language === "fa"
                          ? classes.outlinedInputRtlTextarea
                          : classes.outlinedInputLtrTextarea
                      }
                    >
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="messageText"
                          multiline
                          minRows={8}
                          onChange={(event) => handleChangeInputs(event)}
                          value={messageValues.messageText}
                          startAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("notifications.message_text")}
                              </InputAdornment>
                            )
                          }
                          endAdornment={
                            i18n.language === "en" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("notifications.message_text")}
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div className={classes.mainListContainer}>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        // variant="fullWidth"
                        aria-label="full width tabs example"
                        style={{
                          direction: i18n.language === "en" ? "ltr" : "rtl",
                        }}
                      >
                        <Tab
                          label={t("notifications.user_tab_title")}
                          {...a11yProps(0)}
                        />
                        <Tab
                          label={t("notifications.group_tab_title")}
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </AppBar>
                    <SwipeableViews
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={tabValue}
                      onChangeIndex={handleChangeIndex}
                      style={{
                        padding: 0,
                        backgroundColor: "#e7ecf4",
                        borderRadius: "1em",
                      }}
                    >
                      <TabPanel
                        value={tabValue}
                        index={0}
                        dir={theme.direction}
                      >
                        <div className={` ${classes.listContainer}`}>
                          <ul className={classes.ulList}>
                            {userData.length > 0 &&
                              userData.map((s, index) => (
                                <li
                                  className={`${classes.liList} ${
                                    s.checked === true
                                      ? classes.liListSelected
                                      : ""
                                  } groups-users--user`}
                                  style={{
                                    flexDirection:
                                      i18n.language === "en"
                                        ? "row-reverse"
                                        : "row",
                                  }}
                                  key={s.pk + Math.random()}
                                  onClick={userCheckboxHandleChange(index)}
                                >
                                  <span>
                                    {s.first_name + " " + s.last_name}
                                  </span>
                                  <Checkbox
                                    ref={elUserRefs[index]}
                                    color="primary"
                                    checked={userReceivers[index]}
                                    onChange={userCheckboxHandleChange(index)}
                                  />
                                </li>
                              ))}
                          </ul>
                        </div>
                      </TabPanel>
                      <TabPanel
                        value={tabValue}
                        index={1}
                        dir={theme.direction}
                      >
                        <div className={` ${classes.listContainer}`}>
                          <ul className={classes.ulList}>
                            {groupData.length > 0 &&
                              groupData.map((s, index) => (
                                <li
                                  className={`${classes.liList} ${
                                    s.checked === true
                                      ? classes.liListSelected
                                      : ""
                                  } groups-users--user`}
                                  key={s.pk + Math.random()}
                                  onClick={groupCheckboxHandleChange(index)}
                                >
                                  <span>{s.title}</span>
                                  <span className="userInGroup-step-one">
                                    <Checkbox
                                      ref={elGroupRefs[index]}
                                      color="primary"
                                      checked={groupReceivers[index]}
                                      onChange={groupCheckboxHandleChange(
                                        index
                                      )}
                                    />
                                  </span>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </TabPanel>
                    </SwipeableViews>
                  </div>
                </div>
              </div>
              <Button
                variant="contained"
                className="btn btn-primary jr-btn-uptin"
                onClick={() => handleSubmitMessage()}
                disabled={disableSubmit}
              >
                <span>{t("notifications.send_notification")}</span>
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default withStyles(styles)(AddNotification);
